import React from 'react';
import '../.././components/css/popupstyle.css';
import EyeInActive from '../../components/css/dark/img/eye_selected.png';
import EyeActive from '../../components/css/dark/img/eye_icon.png';
import TrueIcon from '../../components/css/dark/img/true-icon.png';
import RefreshIcon from '../../components/css/dark/img/regenerate.svg';
import WarnIcon from '../../components/css/dark/img/warning.svg';
import InfoIcon from '../../components/css/dark/img/info-icon.svg';
import MinusIcon from '../../components/css/dark/img/theme-images/rx-minus.svg';
import PlusIcon from '../../components/css/dark/img/theme-images/rx-close.svg';
import MinusIconGreen from '../../components/css/dark/img/theme-images/rx-minus-green.svg';
import PlusIconGreen from '../../components/css/dark/img/theme-images/rx-close-green.svg';
import copy from "copy-to-clipboard";
import $ from 'jquery';
import { userService } from '../../_services/user.service';

class GlicApi extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            userdata: JSON.parse(localStorage.getItem('user')),
            clientSecret: this.props.protectedData,
            eyeIcon: false,
            copy_tooltip: '',
            successIpAddress: '',
            errorIpAddress: '',
            bearerToken: null,
            showBearerToken: false,
            tokenLoading: false,
            tokenError: '',
            tokenCopyTooltip: 'Show/Copy Token',
            tokenRegenTooltip: 'Regenerate Token. Your old token(s) will be lost after this!',
            tokenList: [],
            tokenListLoading: false,
            bearerAvailable: true
        }
    }
    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);

        // Load token list on component mount
        this.loadTokenList();
    }
    loadTokenList = () => {
        try {
            this.setState({ tokenListLoading: true });

            const clientId = this.props.glicData[0].client_Id || ''; // this.props.glicData[0].client_Id;
            const basicAuthToken = 'Basic ' + btoa('23bytes1:vtak2e8Klk474Ziyr1HW');

            userService.listTokens(clientId, basicAuthToken).then(
                response => {
                    if (response && response.tokens) {
                        if (response.tokens.length > 0) {

                            this.setState({
                                tokenList: response.tokens,
                                tokenListLoading: false,
                                bearerAvailable: true
                            });
                        } else {
                            this.setState({
                                tokenList: [],
                                tokenListLoading: false,
                                bearerAvailable: false
                            });
                        }
                    } else {
                        this.setState({
                            tokenList: [],
                            tokenListLoading: false,
                            bearerAvailable: false
                        });
                    }
                }
            ).catch(error => {
                this.setState({
                    tokenList: [],
                    tokenListLoading: false,
                    bearerAvailable: false
                });
            });
        } catch (error) {
            this.setState({
                tokenList: [],
                tokenListLoading: false,
                bearerAvailable: false
            });
        }
    }
    handleEye = () => {
        try {
            if (this.state.eyeIcon == false) {
                copy(this.props.glicData[0].client_Secret);
                this.setState({ clientSecret: this.props.glicData[0].client_Secret, eyeIcon: true, copy_tooltip: "Copied" });
                setTimeout(() => {
                    this.setState({ copy_tooltip: "" });
                }, 1000)

            } else {
                this.setState({ clientSecret: this.props.protectedData, eyeIcon: false });
            }
        } catch (error) {
        }
    }
    handleApiAddModal = () => {
        try {
            this.props.closeGlicPopup()
            this.props.openApiAddModal()
        } catch (error) {
        }
    }
    HandleGenerateToken = () => {
        try {
            if (this.state.bearerToken) {
                this.setState({ showBearerToken: false });
                return;
            }

            this.setState({ tokenLoading: true, tokenError: '' });

            const clientId = this.props.glicData[0].client_Id || '';// this.props.glicData[0].client_Id;
            const clientSecret = this.props.glicData[0].client_Secret || '';//this.props.glicData[0].client_Secret;
            const basicAuthToken = 'Basic ' + btoa('23bytes1:vtak2e8Klk474Ziyr1HW');

            userService.generatebearerToken(clientId, clientSecret, basicAuthToken).then(
                response => {
                    if (response && response.accessToken) {
                        this.setState({
                            bearerToken: response.accessToken,
                            showBearerToken: false,
                            tokenLoading: false,
                            tokenError: ''
                        });

                        // Reload token list to show new token information
                        this.loadTokenList();
                    } else {
                        this.setState({
                            tokenLoading: false,
                            tokenError: 'Failed to generate token. Please try again.'
                        });
                    }
                }
            ).catch(error => {
                this.setState({
                    tokenLoading: false,
                    tokenError: 'Failed to generate token. Please try again.'
                });
            });
        } catch (error) {
            this.setState({
                tokenLoading: false,
                tokenError: 'Error generating token.'
            });
        }
    }
    HandleRegenerateToken = () => {
        try {
            this.setState({ tokenLoading: true, tokenError: '' });

            const clientId = this.props.glicData[0].client_Id || '';// this.props.glicData[0].client_Id;
            const clientSecret = this.props.glicData[0].client_Secret || '';//this.props.glicData[0].client_Secret;
            const basicAuthToken = 'Basic ' + btoa('23bytes1:vtak2e8Klk474Ziyr1HW');

            userService.regeneratebearerToken(clientId, clientSecret, basicAuthToken).then(
                response => {
                    if (response && response.accessToken) {
                        this.setState({
                            bearerToken: response.accessToken,
                            tokenLoading: false,
                            showBearerToken: false,
                            tokenError: '',
                            tokenRegenTooltip: 'Token Regenerated!'
                        });

                        // Reload token list to show updated information
                        this.loadTokenList();

                        setTimeout(() => {
                            this.setState({ tokenRegenTooltip: 'Your old token(s) will be lost after this!' });
                        }, 2000);
                    } else {
                        this.setState({
                            tokenLoading: false,
                            tokenError: 'Failed to regenerate token. Please try again.'
                        });
                    }
                }
            ).catch(error => {
                this.setState({
                    tokenLoading: false,
                    tokenError: 'Failed to regenerate token. Please try again.'
                });
            });
        } catch (error) {
            this.setState({
                tokenLoading: false,
                tokenError: 'Error regenerating token.'
            });
        }
    }
    handleCopyToken = () => {
        copy(this.state.bearerToken);
        this.setState({ tokenCopyTooltip: 'Copied!' });
        setTimeout(() => {
            this.setState({ tokenCopyTooltip: 'Hide Token', showBearerToken: !this.state.showBearerToken });
        }, 1000);
    }
    RemoveWhiteListedIPs(ipObjectId) {
        try {
            userService.ResetWhiteListIP(ipObjectId, this.state.userdata.email, '').then(
                apidata => {
                    if (apidata[0].code === '1') {
                        this.setState({ successIpAddress: apidata[0].message, errorIpAddress: '' })
                    } else {
                        this.setState({ errorIpAddress: apidata[0].message, successIpAddress: '' })
                    }
                    if (this.props.ipListUpdated) this.props.ipListUpdated()
                    setTimeout(() => {
                        this.setState({ successIpAddress: '', errorIpAddress: '' })
                    }, 3000)
                }
            );
        }
        catch (error) { }
    }
    maskText(text) {
        if (text.length <= 5) return text; // too short to mask
        const start = text.slice(0, 3);
        const end = text.slice(-2);
        return `${start}***************${end}`;
    };
    formatPrettyDate(dateStr) {
        const date = new Date(dateStr);

        const day = date.getDate();

        // Get ordinal suffix
        const suffix =
            day % 10 === 1 && day !== 11 ? "st" :
                day % 10 === 2 && day !== 12 ? "nd" :
                    day % 10 === 3 && day !== 13 ? "rd" : "th";

        const month = date.toLocaleString('en-GB', { month: 'short' }); // "Nov"
        const year = date.getFullYear();

        return `${day}${suffix} ${month} ${year}`;
    };
    render() {
        let hosturl = window.location.host;
        const { loader, clientSecret, eyeIcon, copy_tooltip, successIpAddress, errorIpAddress, bearerToken, showBearerToken, tokenLoading, tokenError, tokenCopyTooltip, tokenRegenTooltip, tokenList, tokenListLoading, bearerAvailable } = this.state;
        return (
            <div className='popup mfp-zoom-in'>
                <div className='popup_inner manage-distributor-design glic-api'>
                    {
                        loader ? (<div className="theme-loader"></div>) : null
                    }
                    <h1>{this.props.text}<button onClick={this.props.closeGlicPopup}>X</button></h1>
                    <div className="api-section">
                        <div className="same">
                            <span className="left-one">Link to API Documentation: </span>
                            <span className="right-one"><a href="https://documenter.getpostman.com/view/7488757/UVC9i6FE" target="_blank" rel="noreferrer">Click Here to Open</a></span>
                        </div>
                        <div className="same">
                            <span className="left-one">Client Id: </span>
                            <span className="right-one">{this.props.glicData[0].client_Id}</span>
                        </div>
                        <div className="same">
                            <span className="left-one">Client Secret: </span>
                            <span className="right-one"><span className="client-secret"><span className="text">{clientSecret}</span><span className="eyeicon">{eyeIcon ? <img onClick={this.handleEye} src={EyeActive} alt="" /> : <img onClick={this.handleEye} src={EyeInActive} alt="" />}</span>{copy_tooltip && <span className="copy-id">{copy_tooltip}</span>}</span></span>
                        </div>
                        <div className="same">
                            <span className="left-one">Token Based Auth: </span>
                            <span className="right-one">
                                {bearerAvailable ? <span className="client-secret auth-token">
                                    <>
                                        {bearerToken && <span className="text">
                                            {showBearerToken ? this.maskText(bearerToken) : '********************'}
                                        </span>}
                                        {bearerToken && <>{showBearerToken ? <span className="eyeicon">
                                            <img
                                                onClick={() => this.setState({ showBearerToken: !this.state.showBearerToken, tokenCopyTooltip: 'Show/Copy Token' })}
                                                src={EyeActive}
                                                alt="Toggle visibility"
                                            />
                                            {tokenCopyTooltip && <span className={`copy-id ${tokenCopyTooltip === 'Show/Copy Token' ? 'copy-id-left' : ''}`}>{tokenCopyTooltip}</span>}
                                        </span> : <span className="eyeicon token-copy-icon">
                                            <img
                                                onClick={this.handleCopyToken}
                                                src={EyeInActive}
                                                alt="Copy token"
                                            />
                                            {tokenCopyTooltip && <span className={`copy-id ${tokenCopyTooltip === 'Show/Copy Token' ? 'copy-id-left' : ''}`}>{tokenCopyTooltip}</span>}
                                        </span>}</>}
                                        <div className="regenerate-icon">
                                            <img
                                                onClick={this.HandleRegenerateToken}
                                                src={RefreshIcon}
                                                className="token-regenerate-btn"
                                                alt="Regenerate"
                                            />
                                            {tokenRegenTooltip && <span className={tokenRegenTooltip === 'Token Regenerated!' ? "copy-id show" : "copy-id"}><img src={WarnIcon} alt="Info" style={{marginBottom: '-3px', display: 'inline-block'} } /> {tokenRegenTooltip}</span>}
                                        </div>
                                    </>
                                </span> : (<div className="api-btn with-error generate-token"><button className="btn" onClick={this.HandleGenerateToken}>Generate Token {tokenLoading && <div className="defloader small"></div>}</button></div>)}
                            </span>
                        </div>
                        {tokenError && (
                            <div className="same">
                                <span className="left-one"></span>
                                <span className="right-one">
                                    <span className="token-error-message">{tokenError}</span>
                                </span>
                            </div>
                        )}
                        {tokenListLoading ? (
                            <div className="same">
                                <span className="left-one"></span>
                                <span className="right-one">
                                    <span className="token-loading-text">Loading token information...</span>
                                </span>
                            </div>
                        ) : tokenList && tokenList.length > 0 ? (
                            tokenList.map((token, index) => (
                                <div className="same token-info-row" key={token.tokenId}>
                                    <span className="left-one">{index === 0 ? 'Token Info:' : ''}</span>
                                    <span className="right-one" style={{ lineHeight: '22px' }}>
                                        <span className="token-details">
                                            <strong>Created:</strong> {this.formatPrettyDate(token.issuedAt)} <img src={InfoIcon} alt="Info" className="icon" />
                                            <span className="copy-id"><strong> Last Used:</strong> {token.lastUsedAt ? new Date(token.lastUsedAt).toLocaleString() : 'Never'}<br /><strong> Days Left:</strong> {token.daysLeft}</span>
                                        </span>
                                    </span>
                                </div>
                            ))
                        ) : null}
                        <div className="same">
                            <span className="left-one">Pricing Endpoint: </span>
                            <span className="right-one">{this.props.glicData[0].pricing_Endpoint == true ? <img className="true-icon" src={TrueIcon} alt="True icon" /> : ''}</span>
                        </div>
                        <div className="same">
                            <span className="left-one">Data Endpoint: </span>
                            <span className="right-one">{this.props.glicData[0].data_Endpoint == true ? <img className="true-icon" src={TrueIcon} alt="True icon" /> : ''}</span>
                        </div>
                        <div className="same">
                            <span className="left-one">Enrollment Endpoint: </span>
                            <span className="right-one">{this.props.glicData[0].enrollment_Endpoint == true ? <img className="true-icon" src={TrueIcon} alt="True icon" /> : ''}</span>
                        </div>
                        <div className="same">
                            <span className="left-one">Dashboard Endpoint: </span>
                            <span className="right-one">{this.props.glicData[0].dashboard_Endpoint == true ? <img className="true-icon" src={TrueIcon} alt="True icon" /> : ''}</span>
                        </div>
                        <div className="same">
                            <span className="left-one">Implementation/UAT: </span>
                            <span className="right-one">https://uatapi.glichealth.com/</span>
                        </div>
                        <div className="same">
                            <span className="left-one">Production: </span>
                            <span className="right-one">https://api.glichealth.com/</span>
                        </div>
                        {
                            hosturl == 'staging.glichealth.com' || hosturl == 'reporting.nulifespanrx.com' || hosturl == 'reporting.glichealth.com' || hosturl == 'dev.glichealth.com' || hosturl == 'localhost:5464' ?
                                <div className="same">
                                    <span className="left-one">Whitelisted
                                        {this.props.glicIps.length && this.props.glicIps[0].sType === 'Dynamic IP' ? " Domain" : " IP's"}: </span>
                                    <span className="right-one ips-list-right">
                                        <ul className="ips-list">
                                            {this.props.glicIps.map((ip) => <li key={ip.objectUid}>{ip.ipdns} {(this.props.glicIps.length > 1) && <div className="custom-tooltip"><img src={(window.location.host.split('.').slice(-2).join('.').toLowerCase() === "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() === "localhost:5464" || window.location.host.toLowerCase() === "tempfilter-dev.glichealth.com") ? MinusIcon : MinusIconGreen} alt="Minus" className="minus-icon" onClick={() => this.RemoveWhiteListedIPs(ip.objectUid)} /><span className="hover-tooltip createNew edit">Remove {this.props.glicIps.length && this.props.glicIps[0].sType === 'Dynamic IP' ? "Domain" : "IP"}</span></div>}</li>)}
                                        </ul>
                                        <button className="addip-btn custom-tooltip" type="button" onClick={this.handleApiAddModal}>
                                            <img src={(window.location.host.split('.').slice(-2).join('.').toLowerCase() === "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() === "localhost:5464" || window.location.host.toLowerCase() === "tempfilter-dev.glichealth.com") ? PlusIcon : PlusIconGreen} alt="Plus" />
                                            <span className="hover-tooltip">Add new {this.props.glicIps.length && this.props.glicIps[0].sType === 'Dynamic IP' ? "Domain" : "IP"}</span>
                                        </button>
                                    </span>
                                </div> : null
                        }
                    </div>
                    <div className="api-btn with-error">
                        <input type="button" className='btn' onClick={this.props.closeGlicPopup} value="Close" />
                        {(errorIpAddress || successIpAddress) ?
                            <div className="form-group"><div className="Error help-block">{errorIpAddress || successIpAddress}</div></div> : null
                        }
                    </div>
                </div>
            </div>
        );
    }
}
export default GlicApi;
